export enum ELanguages {
    RUS = 'rus',
    UKR = 'ukr',
}